const ArrayDefaultValueInput = () => {
  return null;
};

export default ArrayDefaultValueInput;
